export enum PaymentStatus {
  Approved = "A",
  Declined = "D",
  WaitingPayment = "W",
}

export enum OrderStatus {
  Confirmed = "C",
  Paid = "P",
  Handling = "H",
  Invoiced = "I",
  Shipped = "S",
  Delivered = "D",
  Cancelled = "L",
  Waiting = "W",
  Error = "E",
  CancellationRequest = "CR",
}

export enum OrderSalesChannel {
  TALK2BUY = "Talk2Buy",
}
